import React, { useEffect, useState } from 'react';
import { useApiCaller } from '../../utils/ApiUtilities';
import { getSuperAdminStatsUrl } from '../../utils/UrlUtilities';

function KpiCard({ label, value, color = 'primary' }) {
    return (
        <div className="col-md-3 mb-3">
            <div className={`card border-${color}`}>
                <div className="card-body text-center">
                    <div className="text-muted small">{label}</div>
                    <div className={`display-6 text-${color}`}>{value}</div>
                </div>
            </div>
        </div>
    );
}

function BarRow({ label, count, max }) {
    const pct = max > 0 ? Math.max(2, (count / max) * 100) : 0;
    return (
        <div className="d-flex align-items-center mb-1">
            <div style={{ width: 100 }} className="small text-muted">{label}</div>
            <div className="flex-grow-1">
                <div className="progress" style={{ height: 14 }}>
                    <div
                        className="progress-bar bg-info"
                        role="progressbar"
                        style={{ width: `${pct}%` }}
                    />
                </div>
            </div>
            <div style={{ width: 40 }} className="text-end small ms-2">{count}</div>
        </div>
    );
}

function AdminCard({ admin }) {
    const max = Math.max(1, ...admin.by_day.map(b => b.count));
    return (
        <div className="card mb-3">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="mb-0">{admin.admin_name}</h5>
                    <div>
                        <span className="badge bg-secondary me-1">Today: {admin.today}</span>
                        <span className="badge bg-info text-dark me-1">Week: {admin.this_week}</span>
                        <span className="badge bg-primary me-1">Month: {admin.this_month}</span>
                        <span className="badge bg-success">All: {admin.total}</span>
                    </div>
                </div>
                {admin.by_day.length === 0 ? (
                    <div className="text-muted small">No activity in the last 30 days.</div>
                ) : (
                    <div>
                        <div className="small text-muted mb-1">Last 30 days</div>
                        {admin.by_day.map((b) => (
                            <BarRow key={b.date} label={b.date} count={b.count} max={max} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default function AdminStatsDashboard() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const CallApi = useApiCaller();

    useEffect(() => {
        (async () => {
            const res = await CallApi({ url: getSuperAdminStatsUrl(), method: 'GET' });
            if (res.success) setStats(res.data);
            setLoading(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) return <div>Loading…</div>;
    if (!stats) return <div className="text-muted">No data.</div>;

    return (
        <div>
            <h4>Productivity Stats</h4>
            <div className="row">
                <KpiCard label="Today" value={stats.totals.today} color="secondary" />
                <KpiCard label="This week" value={stats.totals.this_week} color="info" />
                <KpiCard label="This month" value={stats.totals.this_month} color="primary" />
                <KpiCard label="All time" value={stats.totals.all_time} color="success" />
            </div>

            <h5 className="mt-3 mb-3">Per Admin</h5>
            {stats.per_admin.length === 0 && (
                <div className="text-muted">No admins yet.</div>
            )}
            {stats.per_admin.map(a => <AdminCard key={a.admin_id} admin={a} />)}
        </div>
    );
}
